import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Title from '../../../components/Title';
import { routePaths } from '../../../router/paths';
import { currentLang } from '../../../../../utils/lang';
const Customize = () => {
    const { t } = useTranslation();
    const currentLocale = currentLang();
    return (_jsxs("div", { children: [_jsx(Title, { title: t('store_locator.customize.title') }), _jsxs("div", { className: "list-group list-group-padless mb-4", children: [_jsx(Link, { to: routePaths.Accessories[currentLocale], className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: t('store_locator.customize.accessories') }), _jsx(Link, { to: routePaths.Engraving[currentLocale], className: "list-group-item list-group-item-action list-group-item-arrowed-right", children: t('store_locator.customize.engraving') })] })] }));
};
export default Customize;
